export default "__VITE_ASSET__52e55293__"